import gql from 'graphql-tag'

export const GET_PRESET_LIST = gql`
  query GetPresets {
    presets {
      id
      name
      cover {
        id
        url
      }
      presetCategory {
        id
        name
      }
      presetGroups {
        id
        name
      }
      presetMaterials {
        id
        material {
          id
          name
        }
      }
      materials {
        id
        name
      }
      steps {
        id
        name
      }
    }
    presetGroups {
      id
      name
    }
    presetCategories {
      id
      name
    }
  }
`

export const GET_PRESET_BY_ID = gql`
  query GetPresetById($id: Int!) {
    preset(id: $id) {
      id
      name
      cover {
        id
        name
        url
      }
      presetCategory {
        id
        name
      }
      presetGroups {
        id
        name
      }
      presetMaterials {
        id
        material {
          id
          name
          images {
            id
            url
          }
        }
        desc
        extracting
      }
      materials {
        id
        name
        images {
          id
          url
        }
      }
      steps {
        id
        name
      }
    }
    steps {
      id
      stepType {
        id
        name
      }
      name
      needTool
    }
    categories {
      id
      name
      description
      remark
      materials {
        id
        name
        cover {
          id
          url
        }
        images {
          id
          url
        }
      }
    }
  }
`
